import { useEffect, useState } from "react";
import { FaRegStar, FaStar } from "react-icons/fa";

export const userType = {
    doctor: 1,
    patient: 2,
    admin: 3,
};

export const appointmentType = {};

export const verify = {
    verify: true,
    notVerify: false,
};

export const COOKIES_KEY = {
    LANGUAGE_ABB: "language_abb",
};

// export const addQueryParameter = (params) => {
//     return Object.entries(params)
//         .filter(([_, value]) => value !== undefined && value !== null)
//         .map(
//             ([key, value]) =>
//                 `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
//         )
//         .join("&");
// };

export const addQueryParameter = (params) => {
    return Object.entries(params)
        .filter(([_, value]) => value !== undefined && value !== null)
        .flatMap(([key, value]) =>
            Array.isArray(value)
                ? value.map(
                    (v) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`
                )
                : `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join("&");
};

export const validate = (fields, validationRules) => {
    const errors = {};

    for (let field in fields) {
        const value = fields[field];
        const rules = validationRules[field];
        if (rules) {
            if (rules.required && !value) {
                errors[field] = `${field} is required.`;
            } else if (rules.minLength && value.length < rules.minLength) {
                errors[
                    field
                ] = `${field} must be at least ${rules.minLength} characters.`;
            } else if (rules.maxLength && value.length > rules.maxLength) {
                errors[
                    field
                ] = `${field} must be no more than ${rules.maxLength} characters.`;
            } else if (rules.email && !/\S+@\S+\.\S+/.test(value)) {
                errors[field] = `${field} must be a valid email address.`;
            } else if (
                rules.password &&
                !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/.test(
                    value
                )
            ) {
                errors[
                    field
                ] = `${field} must contain at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character.`;
            } else if (field === "confirmPassword" && value !== fields.password) {
                errors[field] = `Password confirmation does not match.`;
            } else if (field === "otp" && (value.length < 6 || value.length > 6)) {
                errors[field] = "OTP must be exactly 6 characters long.";
            } else if (rules.phoneNumber && !/^\+?[1-9]\d{1,14}$/.test(value)) {
                errors[field] = `${field} must be a valid phone number.`;
            } else if (field === "message" && rules.required && !value.trim()) {
                errors[field] = "Message is required.";
            } else if (
                field === "message" &&
                rules.minLength &&
                value.length < rules.minLength
            ) {
                errors[
                    field
                ] = `Message must be at least ${rules.minLength} characters.`;
            } else if (
                field === "message" &&
                rules.maxLength &&
                value.length > rules.maxLength
            ) {
                errors[
                    field
                ] = `Message must be no more than ${rules.maxLength} characters.`;
            }
        }
    }

    return errors;
};

export const getClassNameFromPath = (pathname) => {
    switch (true) {
        case pathname.includes("/login"):
            return "login-class exado-bg-img";
        case pathname.includes("/register"):
            return "register-class exado-bg-img";
        case pathname.includes("/verify-otp"):
            return "verify-otp-class exado-bg-img";
        case pathname.includes("/forgot-password"):
            return "forgot-password-class exado-bg-img";
        case pathname.includes("/doctor/contact"):
            return "contact-class exado-bg-img";
        case pathname.includes("/doctor/login"):
            return "doctor-login-class exado-bg-img";
        case pathname.includes("/doctor/register"):
            return "doctor-register-class exado-bg-img";
        case pathname.includes("/doctor/verify-otp"):
            return "doctor-verify-otp-class exado-bg-img";
        case pathname.includes("/doctor/forgot-password"):
            return "doctor-forgot-password-class exado-bg-img";
        case pathname.includes("/doctor/dashboard"):
        case pathname.includes("/patient/dashboard"):
            return "doctor-dashboard ";
        case pathname.includes("/doctor/my-fees"):
            return "doctor-my-fees";
        case pathname.includes("/doctor/my-schedule"):
            return "doctor-my-schedule";
        case pathname.includes("/doctor/clinic-schedule"):
            return "doctor-clinic-schedule";
        case pathname.includes("/doctor/my-doctors"):
            return "doctor-my-doctors";
        case pathname.includes("/doctor/doctor-Schedule"):
            return "doctor-Schedule";
        case pathname.includes("/doctor/doctor-detail"):
            return "doctor-detail";
        case pathname.includes("/doctor/emergency-calls"):
            return "doctor-emergency-calls";
        case pathname.includes("/doctor/faq"):
            return "doctor-faq";
        case pathname.includes("/doctor/list-of-invoices"):
            return "doctor-list-of-invoices";
        case pathname.includes("/doctor/invoices-setting"):
            return "doctor-invoices-setting";
        case pathname.includes("/doctor/generate-invoice"):
            return "doctor-generate-invoice";
        case pathname.includes("/doctor/pdf-preview"):
            return "doctor-pdf-preview";
        case pathname.includes("/doctor/my-patients"):
            return "doctor-my-patients";
        case pathname.includes("/doctor/my-finances"):
            return "doctor-my-finances";
        case pathname.includes("/patient/chat-cancelled"):
        case pathname.includes("/doctor/chat-cancelled"):
        case pathname.includes("/patient/chat-completed"):
        case pathname.includes("/doctor/chat-completed"):
        case pathname.includes("/patient/chat-ongoing"):
        case pathname.includes("/doctor/chat-ongoing"):
        case pathname.includes("/patient/chat-requested"):
        case pathname.includes("/doctor/chat-requested"):
            return "doctor-chats";
        case pathname.includes("/patient/appointment-request"):
        case pathname.includes("/doctor/appointment-request"):
        case pathname.includes("/patient/appointment-completed"):
        case pathname.includes("/doctor/appointment-completed"):
        case pathname.includes("/patient/appointment-upcoming"):
        case pathname.includes("/doctor/appointment-upcoming"):
        case pathname.includes("/patient/appointment-cancelled"):
        case pathname.includes("/doctor/appointment-cancelled"):
            return "doctor-appointments";
        case pathname.includes("/doctor/diagnostic-report"):
            return "doctor-diagnostic-report";
        case pathname.includes("/doctor/mass-messages"):
            return "doctor-mass-messages";
        case pathname.includes("/patient/my-profile"):
            return "patient-my-profile";
        case pathname.includes("/doctor/my-profile"):
            return "doctor-my-profile ";
        case pathname.includes("/doctor/patient-details"):
            return "patient-details";
        case pathname.includes("/doctor"):
            return "d-land-page-main";
        case pathname.includes("/book-an-appointment"):
            return "book-an-appointment-main";
        case pathname.includes("/admin/login"):
            return "admin-login-class exado-bg-img";
        case pathname.includes("/"):
            return "d-land-page-main";
        default:
            return "";
    }
};

export const maskEmail = (email) => {
    if (typeof email !== "string" || !email.includes("@")) {
        console.error("Invalid email input:", email);
        return "";
    }

    const [user, domain] = email.split("@");
    const maskedUser = user.slice(0, 1) + "***";

    if (!domain.includes(".")) {
        console.error("Invalid domain in email:", domain);
        return "";
    }

    const [domainName, domainExtension] = domain.split(".");
    const maskedDomain = domainName.slice(0, 3) + "***";
    return `${maskedUser}@${maskedDomain}.${domainExtension}`;
};

export const StarRating = ({ rating, maxStars = 5 }) => {
    return (
        <div className="star-rating">
            {Array.from({ length: maxStars }, (_, index) => (
                <span key={index} className="star-rating-size-color">
                    {index < rating ? <FaStar /> : <FaRegStar />}
                </span>
            ))}
        </div>
    );
};

export const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th"; // Covers 11th, 12th, 13th
    switch (day % 10) {
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
};

export const formatDateWithOrdinal = (date) => {
    const day = date.getDate();
    const month = date.toLocaleDateString("en-GB", { month: "long" });
    const year = date.getFullYear();
    const ordinalSuffix = getOrdinalSuffix(day);

    return `${day}${ordinalSuffix} ${month} ${year}`;
};

export const useTruncateText = (text, maxWords = 41) => {
    const [showFull, setShowFull] = useState(false);

    if (!text) return { displayedText: "", showFull, toggleShow: () => { } };

    const words = text.split(" ");
    const shouldTruncate = words.length > maxWords;
    const displayedText =
        shouldTruncate && !showFull
            ? words.slice(0, maxWords).join(" ") + "..."
            : text + " ...";

    const toggleShow = () => setShowFull(!showFull);

    return { displayedText, showFull, toggleShow, shouldTruncate };
};

export const calculateAge = (dob) => {
    if (!dob) return;

    const birthDate = new Date(dob);
    if (isNaN(birthDate)) return "Invalid Date";

    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age;
};

export const CountdownTimer = ({ appointmentDateTime, timerMinutes, onTimeout }) => {
    const calculateTimeLeft = () => {
        const [min, sec] = timerMinutes.split(":").map(Number);

        // Ensures UTC parsing (prevents time zone mismatch)
        const startTime = new Date(appointmentDateTime + 'Z');
        const endTime = new Date(startTime.getTime() + (min * 60 + sec) * 1000);
        const now = new Date();

        const timeDiff = Math.floor((endTime - now) / 1000); // in seconds

        return timeDiff > 0 ? timeDiff : 0;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

    useEffect(() => {
        if (timeLeft <= 0) {
            if (onTimeout) onTimeout();
            return;
        }

        const interval = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    if (onTimeout) onTimeout();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [timeLeft]);

    const formatTime = () => {
        const m = String(Math.floor(timeLeft / 60)).padStart(2, "0");
        const s = String(timeLeft % 60).padStart(2, "0");
        return `${m}:${s}`;
    };

    return <span className="noVerify">{formatTime()}</span>;
};

export const formatDate = (dateStr) => {
    const dateObj = new Date(dateStr);
    const getOrdinal = (n) => {
        const s = ["th", "st", "nd", "rd"];
        const v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };
    const day = getOrdinal(dateObj.getDate());
    const month = dateObj.toLocaleString("en-US", { month: "long" });
    const year = dateObj.getFullYear();
    const time = dateObj.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    });
    return `${month} ${day}, ${year} at ${time}`;
};
